import { useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import uniqBy from 'lodash.uniqby';
import { useEffect } from 'react';
import NavButton from '../../components/NavButton';
import { useNotificationStore } from '../../components/notificationStore';
import { useUserStore } from '../../components/userStore';

const Services = () => {
	const { user } = useUserStore();
	const { showError } = useNotificationStore();
	const queryClient = useQueryClient();
	const updateServices = useQuery({
		queryKey: ['updateAgencyServices', user.coord_agency.id],
		queryFn: async () => {
			const { data } = await axios.get(
				`/coord_agencies/${user.coord_agency.id}/updateServicesByLocation`,
			);
			return data;
		},
		enabled: false,
	});
	useEffect(() => {
		if (updateServices.isError) {
			showError('Error syncing with hub. Please try again later.');
		}
	}, [updateServices.isError]);

	const exServList = useQuery({
		queryKey: ['externalServicesList', user.coord_agency.id],
		queryFn: async () => {
			const { data } = await axios.get(
				`/coord_agencies/${user.coord_agency.id}/external-services-list`,
			);
			return data;
		},
	});

	const handleSyncHubData = () => {
		updateServices.refetch().finally(() => {
			queryClient.invalidateQueries({
				queryKey: ['externalServicesList', user.coord_agency.id],
			});
		});
	};

	let uniqServices;
	if (exServList.isFetched) {
		uniqServices = uniqBy(exServList.data, 'external_id').map((service) => ({
			...service,
			data: JSON.parse(service.data),
		}));
	}

	// console.log(uniqServices);

	return (
		<>
			<h1>Service Configuration Builder</h1>
			<div className="clear-both px-4 py-4 mt-4 bg-white rounded-lg">
				<h2>Service Setup Wizard - Configure Service</h2>
				<p className="mt-4">
					We have pulled forward your current registered services from your hub
					(MI211). Below select the “Configure” button below to finish your
					account setup. Once your service is configured and the application is
					setup, the service will be available for use Online.
				</p>
				<table className="table mt-4 table-xs">
					<thead>
						<tr>
							<th>Service / Location(s)</th>
							{/* <th>
								Private
								<br />
								Data
							</th> */}
							<th>Search Term (Taxonomy)</th>
							<th>E-referral Status</th>
						</tr>
					</thead>
					<tbody>
						{exServList.isFetching && (
							<tr>
								<td colSpan={4}>
									<span className="loading loading-spinner text-primary" />
								</td>
							</tr>
						)}
						{exServList.isFetched && uniqServices.length === 0 && (
							<tr>
								<td colSpan={4}>No services found.</td>
							</tr>
						)}
						{!exServList.isFetching &&
							uniqServices &&
							uniqServices.map((service) => (
								<tr key={service.external_id}>
									<td>
										<strong>{service.data.name}</strong>
										<br />
										<em>
											{service.data.locations
												.map(({ name }) => name)
												.join(', ')}
										</em>
									</td>
									{/* <td>
										{service.private_data ? (
											<CheckCircleIcon className="w-6 h-6" />
										) : (
											<XCircleIcon className="w-6 h-6" />
										)}
									</td> */}
									<td>
										{service.data.service_taxonomy
											.map(({ taxonomy_detail }) => `${taxonomy_detail}`)
											.join(', ')}
									</td>
									<td>
										{service.availability ? 'Accepting' : 'Not accepting'}
									</td>
									<td>
										<NavButton
											disabled={updateServices.isFetching}
											to={`/services/${service.id}/configure`}
											title="Configure"
										/>
									</td>
								</tr>
							))}
					</tbody>
				</table>
				<div className="divider" />
				<div>
					<button
						className="btn btn-primary btn-outline btn-wide"
						onClick={handleSyncHubData}
						disabled={updateServices.isFetching || exServList.isFetching}
					>
						{updateServices.isFetching && (
							<span className="loading loading-spinner"></span>
						)}
						Re-Sync Hub Data
					</button>
				</div>
			</div>
		</>
	);
};

export default Services;
